// src/lib/inbox-channels.js — BUG 38 — Registre des canaux Inbox.
//
// ⚠️ SOURCE UNIQUE pour le serveur ET l'écran (F10 phase 2, 03/10). Écrit en
// CommonJS pur : l'écran (InboxComposer, SmsTransversalView) l'importe
// directement ; le serveur le lit par le relais `lib/inbox-channels.js`
// (api/send-email.js, lib/marketing-sms.js…), comme src/lib/sms-validator.js.
// Plus de miroir à tenir en phase : ne rien ajouter qui ne soit chargeable des
// deux côtés (garde : src/lib/doublons-lib-conformite.test.js).
//
// Source de vérité des MÉTADONNÉES de canaux (id / label / enabled /
// coordinateField). Les SENDERS réels restent dans api/send-email.js, mappés
// par `id` (email → sendEmailV2 / Resend, tchat_ota → postBookingMessage /
// Beds24). Ce fichier ne fait PAS d'envoi : il décrit les canaux.
//
// Archi extensible : ajouter un canal = passer `enabled:true` + brancher son
// sender dans send-email.js (aucune refonte de la boucle multi-canal).
//
// Métadonnées :
//   - coordinateField = clé attendue dans le payload pour joindre le voyageur :
//       tchat_ota → beds24_booking_id, email → guest_email,
//       sms / whatsapp → guest_phone.
//
// WAGON N (BUG 51) — décision Dimitri : SMS UNIQUEMENT (pas de WhatsApp).
//   - sms : `enabled` reste FALSE ICI à dessein. Ce flag est l'interrupteur
//     d'INERTIE GLOBAL du canal SMS, lu AUSSI par le parcours direct
//     (lib/journey-comms.js + lib/direct-journey-sweep.js → smsChannelEnabled()).
//     Le passer à true activerait ces envois-là, HORS périmètre WAGON N. Dans
//     l'Inbox (api/send-email.js → inbox_reply), le SMS est néanmoins un canal
//     RÉEL câblé (lib/sender-sms.js), traité comme un canal autorisé MAIS gardé
//     INERTE par MESSAGES_DRY_RUN (= mail : trace sent_dry_run, aucun appel
//     Twilio). cf. INBOX_SMS_WIRED + commentaire send-email.js. L'activation
//     réelle = bascule DRY_RUN par Dimitri (comme le mail).
//   - whatsapp : ⚠️ LE COMMENTAIRE « NON RETENU, DÉFINITIF » QUI VIVAIT ICI EST
//     PÉRIMÉ — la décision Dimitri du 2026-09-06 le remplace :
//     **WhatsApp EN PLUS du SMS, jamais À LA PLACE, avec repli SMS automatique
//     sur non-remise** (docs/handoff/CADRAGE_WHATSAPP.md). Le sender est
//     désormais RÉEL (lib/sender-whatsapp.js, Cloud API Meta) et la machine de
//     repli existe (lib/whatsapp-repli.js).
//     `enabled` reste FALSE, et ce n'est PAS un reliquat : le canal naît éteint.
//     Son interrupteur propre est l'env `WHATSAPP_ENABLED` (fail-closed, ≠
//     'true' ⇒ rien ne part), au-dessus duquel les verrous habituels
//     s'appliquent toujours (MESSAGES_DRY_RUN, real_send_enabled par logement).
//     Le passer à true = décision Dimitri, après modèles Meta approuvés et
//     migration `whatsapp_envois` appliquée.

// ── NOMMAGE (décision Dimitri 2026-09-06, cadrage §5) ───────────────────────
// « SMS » reste le libellé D'ÉCRAN du canal téléphone. Mais dans le CODE et
// dans les JOURNAUX, ce qui part en WhatsApp se nomme `whatsapp` — jamais
// `sms`. Un journal qui dit « sms » alors qu'un WhatsApp est parti coûte une
// heure de diagnostic six mois plus tard, et surtout il FAUSSE la métrique de
// bascule (% de replis) qui doit dire si WhatsApp sert à quelque chose.

const INBOX_CHANNELS = [
  { id: 'tchat_ota', label: 'Chat OTA', coordinateField: 'beds24_booking_id', enabled: true },
  { id: 'email', label: 'Mail', coordinateField: 'guest_email', enabled: true },
  // WAGON N — SMS câblé dans l'Inbox (sender réel) mais enabled:false (interrupteur
  // global partagé parcours direct). Inertie Inbox = MESSAGES_DRY_RUN.
  { id: 'sms', label: 'SMS', coordinateField: 'guest_phone', enabled: false },
  // WhatsApp RETENU depuis le 2026-09-06 (cadrage), mais NAÎT ÉTEINT : son
  // interrupteur est l'env WHATSAPP_ENABLED, pas ce flag. Cf. en-tête.
  { id: 'whatsapp', label: 'WhatsApp', coordinateField: 'guest_phone', enabled: false },
]

// WAGON N — canaux RÉELLEMENT câblés côté Inbox (api/send-email.js → inbox_reply)
// indépendamment du flag d'inertie globale `enabled`. Le SMS y est autorisé même
// si enabled:false (son inertie Inbox est portée par MESSAGES_DRY_RUN, comme le
// mail). N'inclut PAS whatsapp (aucun sender câblé). Source de vérité unique pour
// que l'Inbox ne dépende plus de l'interrupteur global du parcours direct.
// ⚠️ MISE À JOUR 2026-09-06 : « N'inclut PAS whatsapp (aucun sender câblé) »
// n'est plus exact — le sender WhatsApp existe (lib/sender-whatsapp.js). Ce
// drapeau reste néanmoins réservé au SMS : WhatsApp n'est PAS câblé dans
// l'Inbox (il l'est sur le chemin d'envoi automatique + repli), et son
// interrupteur est WHATSAPP_ENABLED, pas celui-ci.
const INBOX_SMS_WIRED = true

function getChannel(id) {
  return INBOX_CHANNELS.find((c) => c.id === id) || null
}

// WAGON N — un canal est-il « actionnable » dans l'Inbox (UI + boucle serveur) ?
// = enabled:true OU câblé spécifiquement (SMS). WhatsApp reste exclu de l'INBOX :
// son montage 2026-09-06 concerne le chemin d'envoi automatique + repli SMS, pas
// la réponse manuelle du composer. (Venu de l'ancienne copie écran ; le serveur
// ne l'appelle pas.)
function isInboxActionable(id) {
  if (id === 'sms') return INBOX_SMS_WIRED
  const ch = getChannel(id)
  return !!(ch && ch.enabled === true)
}

module.exports = { INBOX_CHANNELS, getChannel, INBOX_SMS_WIRED, isInboxActionable }
